/**
 * ...
 * @author fpinn@touchcommerce.com
 */
/**
 * package: com.inq.utils
 * class: Util
 * root Object
 * @constructor
 */
com.inq.utils.Util = function() {};
$hxClasses['com.inq.utils.Util'] = com.inq.utils.Util;
/** @private @type {Array} */
com.inq.utils.Util.__name__ = ["com","inq","utils","Util"];

/**
 * publish - publishes a non obfuscated reference to an object
 * It is unobfuscated due to the fact that it is done at run time and it's reference is defined by a string
 *
 * $type TFun([{ name => path, t => TInst(String,[]), opt => false },{ name => object, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function publish(path:String, object:Dynamic)
 * @public
 * @static
 * @param {string}  path - the string reference to the xpath relative to the window object.  Example "foo.bar.Hello" would be defined as window.foo.bar.Hello
 * @param {null}  object - is the object to be published
 * @return {void}
 */
com.inq.utils.Util.publish = function(path,object) {
	/** @type {Array} */
	var parts = path.split(".");
	/** @type {Window} */
	var point = window;
	/** @type {number} */
	var lastItemIndex = parts.length - 1;
	var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = parts.length;
	while(_g1 < _g) {
		var /** @type {number} */ i = _g1++;
		var /** @type {string} */ partName = parts[i];
		if (null == point[partName]) {
			if (i == lastItemIndex) {
				/*  if this is the last part of the path, then assign the object*/
				point[partName] = object;
			} else {
				/*  If the portion of the path does not exist, then we must define it.*/
				point[partName] = {};
			}
		}
		point = point[partName];
	}
};

/**
 * Returns true if need to use default agent alias.
 * @return {boolean}
 */
com.inq.utils.Util.isDefaultAgentAlias = function() {
    return com.inq.utils.Util.getConfig("useAgentAlias", false) == true &&
        com.inq.flash.client.control.FlashVars.getValue("overrideAgentAlias") != "true" &&
        com.inq.flash.client.control.FlashVars.getValue("overrideChatTheme") != "true";
};

/**
 * getConfig
 *
 * $type TFun([{ name => attrib, t => TInst(String,[]), opt => false },{ name => def, t => TDynamic(null), opt => false }],TDynamic(null))
 * public static function getConfig(attrib:String, def:Dynamic ):Dynamic
 * @public
 * @static
 * @param {string} attrib
 * @param {*=} def - default value (optional)
 * @return {*}
 */
com.inq.utils.Util.getConfig = function(attrib,def) {
	/** @type {?Object} */
	var configMap = null;
	try {
        if (Application.application) {
            configMap = Application.application[com.inq.utils.Util.configArea];
        }

		if (configMap != null) return configMap[attrib] != null ? configMap[attrib] : def;
	} catch (e) {
		haxe.Log.trace("error accessing configuration attribute: " + attrib + "\n" + Std.string(e),{ fileName : "Util.hx", lineNumber : 61, className : "com.inq.utils.Util", methodName : "getConfig"});
	}
	return def;
};

/**
 * Returns the value of attribute as boolean value.
 * @param {string} attributeName
 * @return {boolean}
 */
com.inq.utils.Util.getConfigAsBoolean = function(attributeName) {
	return !!com.inq.utils.Util.getConfig(attributeName);
};

/**
 * getIEMajorVer
 *
 * Get IE browser major version.
 * @param {boolean} compatibility - flag for determine version in compatibility mode
 * @return {number} browser major version or 0 if unable to detect
 */
com.inq.utils.Util.getIEMajorVer = function(compatibility) {
	return com.inq.flash.client.control.FlashPeer.getBrowserMajorVer(compatibility)
};

/**
 * Gets host name from input url
 * @param {string} url
 * @return {string}
 */
com.inq.utils.Util.getHostFromUrl = function(url) {
    return (url.indexOf("/") > -1) ? url.split("/",3)[2] : url;
};

/**
 * Used instead of using a direct window.top call to allow for
 * stubbing the window object in unit tests.
 * @returns {Window}
 */
com.inq.utils.Util.getTopWindow = function getTopWindow() {
	return window.top;
};

/**
 * Returns window.parent.document.referrer
 * @return {string}
 */
com.inq.utils.Util.getParentReferrer = function () {
	return window.parent.document.referrer;
};

/**
 * Returns window.parent.performance.navigation.type
 * @return {number}
 */
com.inq.utils.Util.getNavigationType = function () {
	return window.parent.performance.navigation.type;
};

/**
 * Returns window.parent.location
 * @return {Object}
 */
com.inq.utils.Util.getParentLocation = function () {
	return window.parent.location;
};

/**
 * Gets top window URL
 * @return {string}
 */
com.inq.utils.Util.getTopWindowURL = function() {
    try {
        return window.top.location.href;
    } catch (e) {
        haxe.Log.trace("error accessing window.top.location.\n" + Std.string(e),{ fileName : "Util.js", className : "com.inq.utils.Util", methodName : "getTopWindowURL"});
    }
    return null;
};

/**
 * Used instead of using a direct window.top.visualViewport call to allow for
 * stubbing the visualViewport object in unit tests.
 *
 * At the time of this writing, visualViewport **may return undefined** if it is not implemented in the browser.
 * Check browser compatibility list at https://developer.mozilla.org/en-US/docs/Web/API/VisualViewport#Browser_compatibility
 * Only browsers where it is not implemented as of Nov/2019 are IE, Edge, Samsung Internet. Firefox requires a JS call
 * first to activate.
 *
 * the visualViewport properties we care about are height, and scale.
 * on iOS the scale was set 1
 * So you would get an object that looks like:
 * {
 *     height: 812,
 *     scale: 1
 * }
 *
 * On Chrome however, using a simulated iPhoneX, the object looked like:
 * {
 *     height: 2221.632080078125,
 *     scale: 0.36549708247184753
 * }
 *
 * So we need to do Math.round(height * scale) to get 812
 *
 * @returns {(object|undefined)}
 */
com.inq.utils.Util.getVisualViewport = function getVisualViewport() {
	return this.getTopWindow().visualViewport;
};

/**
 * isFocusAndScrollMonitorsDisabled
 *
 * Determines if the focus and scroll monitors need to be disabled.
 * @return {boolean}
 */
com.inq.utils.Util.isFocusAndScrollMonitorsDisabled = function () {
	try {
		//RTDEV-23853: Disable focus and scroll monitors for the post chat surveys launched thru CEAPI on iOS webviews. (typically those launched from SDK)
		if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()
			|| (com.inq.flash.client.control.FlashPeer.isCEAPIPostChatSurveyMode() && com.inq.utils.Capabilities.isIOSWebView())) {
			return true
		} else {
			return false;
		}
	} catch (e) {
		haxe.Log.trace("Error when determining isFocusAndScrollMonitorsDisabled" + Std.string(e), {
			fileName: "Util.js",
			className: "com.inq.utils.Util",
			methodName: "isFocusAndScrollMonitorsDisabled"
		});
	}
	return false;
};

/**
 * getScrollableContainer
 *
 * Recursively finds the y scrollable container for the element and returns it.
 * @param {?HTMLElement} el - field element
 * @return {object} - scrollable container field
 */
com.inq.utils.Util.getScrollableContainer = function (el) {

	if (!el.parentNode) {
		return null;
	} else if (el.parentNode.id == "tcChat_Skin") {// safety
		return null;
	} else if (el.parentNode.scrollHeight > el.parentNode.clientHeight) { // This indicates the the container is y scrollable
		return el.parentNode;
	} else {
		return com.inq.utils.Util.getScrollableContainer(el.parentNode);
	}
};

/**
 * Returns true if chat skin is in div
 *
 * @return {boolean} - flag which is used for chat type
 */
com.inq.utils.Util.isDivChat = function () {
	if (com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		return false;
	}

	return com.inq.utils.Util.getConfig("divSkin", false)
		|| com.inq.ui.SkinLoader.skinInClient;
};

/**
 * Computes the value of the "boxSizing" property and returns true/false
 * based on the comparison of the received value with the "border-box"
 *
 * @param {HTMLElement} elem
 * @return {boolean}
 */
com.inq.utils.Util.isBorderBoxEnabled = function (elem) {
	/** @type {Window} */
	var chatsWindow = com.inq.utils.Util.isDivChat() ? window.parent : window;
	/** @type {Object} */
	var styles = chatsWindow.getComputedStyle(elem);

	return styles && styles.boxSizing === "border-box";
};

/**
 * This is a regular debounce function.
 * @param func {function} - The function to be debounced
 * @param wait {int} - The time delay in milliseconds
 * @param immediate {boolean} - if true, then it trigger the function on the leading edge, instead of the trailing.
 * @return callBackFun {function} - A debounced call back function
 */
com.inq.utils.Util.debounce = function (func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


com.inq.utils.Util.fields = function(o) {
	/** @type {Array} */
	var a = [];
	if (o != null) {
		for (var f in o) {
			if (o.hasOwnProperty(f)) {
				a.push(f);
			}
		}
	}
	return a;
};

/**
 * Js implementation of Polish notation.
 * For more information please take a look:
 * https://en.wikipedia.org/wiki/Polish_notation
 * Evaluate string expression
 * @param {string} str - expression(will look like '2 + 2')
 * @returns {number} - result of evaluation
 */
com.inq.utils.Util.evalExpression = function (str) {
	var stack = [];
	var out = [];

	// set the priority of the operators, as well as their associativity
	var prior = {
		"^": { prior: 4, assoc: "right" },
		"*": { prior: 3, assoc: "left" },
		"/": { prior: 3, assoc: "left" },
		"+": { prior: 2, assoc: "left" },
		"-": { prior: 2, assoc: "left" },
		"(": { prior: 1, assoc: "left" },
		")": { prior: 1, assoc: "left" }
	};
	var endOp = false;
	var currPrior;
	var currAssoc;
	var prevPrior;
	var lastOp;
	var token = sanitizeString(str);
	var isLastNum = true;

	for (var i = 0; i < token.length; i++) {
		if (token[i].match(/[+\-*/^]/)) {
			endOp = false;
			arithmeticChar(i);
			isLastNum = false;
		} else if (token[i].match(/[0-9.]/)) {
			numericChar(i);
		} else if (token[i] === "(" || token[i] === ")") {
			bracesChar(i);
		}
	}

	var stackSave = stack;
	var finallyLine = out;
	var stackEl = stackSave.pop();

	while (stackEl) {
		finallyLine.push(stackEl);
		stackEl = stackSave.pop();
	}

	return evaluate(finallyLine.join());

	/**
	 * Returns the result of calculating the reverse polish notation
	 * @param {string} expr - Polish notation expression ("2 + 2" => "2,2,+")
	 * @returns {number}
	 */
	function evaluate(expr) {
		var operators = {
			'+': function (x, y) { return x + y; },
			'-': function (x, y) { return y - x; },
			'*': function (x, y) { return x * y; },
			'/': function (x, y) { return y / x; }
		};
		var stackArr = [];
		var exprArray = expr.split(",");

		for (var j = 0; j < exprArray.length; j++) {
			if (exprArray[j] in operators) {
				// In case we catch operator we need perform the appropriate operation on the two previous values
				var x = stackArr.pop();
				var y = stackArr.pop();
				stackArr.push(operators[exprArray[j]](x, y));
			} else {
				// If value is a digit just put it to stack
				stackArr.push(parseFloat(exprArray[j]));
			}
		}

		return stackArr.pop();
	}

	/**
	 * Removes all spaces between chars, replace all commas to dots,
	 * adds 0 symbol if the string has arithmetic signs at the beginning
	 * and replace all places where string has `(-` symbols to `(0-`
	 * @param {string} stringToSanitize
	 * @returns {string} sanitized string
	 */
	function sanitizeString(stringToSanitize) {
		var sanitizedToken = stringToSanitize.replace(/ +?/g, "");
		sanitizedToken = sanitizedToken.replace(/,/g, ".");

		if (sanitizedToken[0].match(/[+\-*/^]/)) {
			sanitizedToken = "0" + sanitizedToken;
		}

		while (sanitizedToken.indexOf("(-") > -1) {
			sanitizedToken = sanitizedToken.replace("(-", "(0-");
		}

		return sanitizedToken;
	}

	/**
	 * If we met an operator.
	 * If there are no operators on the stack, just write the current operator onto the stack and indicate that
	 * the while parsing loop has ended.
	 * If there are operators on the stack, then the last one is now in the lastOp variable
	 * get the priority and associativity of the current operator and compare it with lastOp.
	 * @param index
	 */
	function arithmeticChar(index) {
		while (!endOp) {
			lastOp = stack.pop();

			if (!lastOp) {
				stack.push(token[index]);
				endOp = true;
			} else {
				currPrior = prior[token[index]].prior;
				currAssoc = prior[token[index]].assoc;
				prevPrior = prior[lastOp].prior;

				switch (currAssoc) {
					case "left":
						if (currPrior > prevPrior) {
							stack.push(lastOp);
							stack.push(token[index]);
							endOp = true;
						} else {
							out.push(lastOp);
						}

						break;

					case "right":
						if (currPrior >= prevPrior) {
							stack.push(lastOp);
							stack.push(token[index]);
							endOp = true;
						} else {
							out.push(lastOp);
						}

						break;

					default: break;
				}
			}
		}
	}

	/**
	 * In case we met numeric char just push it to out array.
	 * @param index
	 */
	function numericChar(index) {
		if (isLastNum) {
			var num = out.pop();

			if (num) {
				out.push(num + token[index]);
			} else {
				out.push(token[index]);
			}
		} else {
			out.push(token[index]);
			isLastNum = true;
		}
	}

	/**
	 * In case we met an OPEN parenthesis - we just need to push it onto the stack.
	 * In case we met the CLOSING parenthesis - now we pop all the statements from the top of the stack
	 * into the line until we will meet the Opening parenthesis
	 * @param index
	 */
	function bracesChar(index) {
		if (token[index] === "(") {
			stack.push(token[index]);
			isLastNum = false;
		} else if (token[index] === ")") {
			var isBracket = false;

			while (!isBracket) {
				var op = stack.pop();

				if (op === "(") {
					isBracket = true;
				} else {
					out.push(op);
				}
			}

			isLastNum = false;
		}
	}
};

/**
 * Returns true only if passed parameter is 'null' or 'undefined'
 * @param {*} val
 * @return {boolean}
 */
com.inq.utils.Util.isNullOrUndefined = function (val) {
	return val === null || typeof(val) === "undefined";
};

/** @type {com.inq.utils.Util} */
com.inq.utils.Util.prototype.__class__ = com.inq.utils.Util;
/** @type {boolean} */
com.inq.utils.Util.isIE = window.navigator.appName == "Microsoft Internet Explorer" || window.navigator.userAgent.indexOf("Trident") != -1;

/** @private @type {string} */
com.inq.utils.Util.configArea = "skinConfig";
/** @type {string} */
com.inq.utils.Util.xformsCloseEventFlag = "sendEventChatCloseToAutomatons";

/** @type {String} agent type image constants */
com.inq.utils.Util.SKIN_CONFIG_KEY_AGENT_IMAGE_CONFIG = "agentImageConfig";
com.inq.utils.Util.SKIN_CONFIG_KEY_AGENT_IMAGE_ENABLED = "agentTypeImageEnabled";

com.inq.utils.Util.URL_REGEX = /(https?:\/\/[^"<\s]+)(?![^<>]*>|[^"]*?<\/a)/g;
